import Delta from 'quill-delta';
import getOperationOffset from '../utils/getOperationOffset';
import getNodeLength from '../utils/getNodeLength';
import { BLOCK_DELIMITER_LENGTH } from '../utils/constants';
import { OT_BLOCKS } from '../../../types/BlockTypes';
import convertInlineToAttributes from '../utils/convertInlineToAttributes';

function getRemovedAttributes(op) {
  return Object.keys(op.properties).reduce(function (memo, key) {
    if (!op.newProperties[key]) {
      memo[key] = null;
    }

    return memo;
  }, {});
}

function getAttributes(op) {
  return Object.keys(op.newProperties).reduce(function (memo, key) {
    if (op.newProperties[key].toJS) {
      memo[key] = op.newProperties[key].toJS();
    } else {
      memo[key] = op.newProperties[key];
    }

    return memo;
  }, getRemovedAttributes(op));
}

export default function setNode(op, editor) {
  var node = editor.value.document.getNode(op.path);

  if (OT_BLOCKS.includes(node.type)) {
    return new Delta().retain(getOperationOffset(op, editor)).retain(getNodeLength(node) - BLOCK_DELIMITER_LENGTH).retain(BLOCK_DELIMITER_LENGTH, getAttributes(op));
  } else if (node.object === 'inline') {
    return new Delta().retain(getOperationOffset(op, editor)).retain(getNodeLength(node), convertInlineToAttributes(node.merge(op.newProperties)));
  }
}